document.addEventListener('DOMContentLoaded', function() {
  const tabTitles = document.querySelectorAll('.tabs-titles > div');
  const tabContents = document.querySelectorAll('.tab-content');

  tabTitles.forEach(title => {
    title.addEventListener('click', function() {
      const targetIndex = this.getAttribute('data-index');
      
      // 移除所有active类
      tabTitles.forEach(t => t.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active', 'fade_in'));
      
      // 同步桌面端和移动端的选中状态
      document.querySelectorAll(`[data-index="${targetIndex}"]`).forEach(tab => {
        tab.classList.add('active');
      });
      
      // 显示对应内容
      const targetContent = document.getElementById(`tab-${targetIndex}`);
      if (targetContent) {
        targetContent.classList.add('active');
        setTimeout(() => {
          targetContent.classList.add('fade_in');
        }, 50);
      }
    });
  });

  // FAQ折叠功能 - 只在移动端的FAQ上工作
  document.addEventListener('click', function(e) {
    const clickedFaqQuestion = e.target.closest('.mobile-only .m-faq-i-q');
    if (clickedFaqQuestion) {
      const isOpen = clickedFaqQuestion.getAttribute('data-faqopen') === 'true';
      const faqAnswer = clickedFaqQuestion.nextElementSibling;
      
      if (isOpen) {
        // 关闭FAQ
        clickedFaqQuestion.setAttribute('data-faqopen', 'false');
        faqAnswer.classList.add('active');
      } else {
        // 打开FAQ
        clickedFaqQuestion.setAttribute('data-faqopen', 'true');
        faqAnswer.classList.remove('active');
      }
    }
  });
});